import { render } from "./BannerTable.vue?vue&type=template&id=225ffa65&scoped=true"
import script from "./BannerTable.vue?vue&type=script&lang=js"
export * from "./BannerTable.vue?vue&type=script&lang=js"

import "./BannerTable.vue?vue&type=style&index=0&id=225ffa65&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225ffa65"]])

export default __exports__